import { DateWrapperUtility } from './date-wrapper.utility';

export const getDayCountFromNow = (date: string): number => {
  return DateWrapperUtility.dayCountFromNow(date);
};
